import { BreadcrumbComponent } from 'ccs-ui-components';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { EVENT_ASSOCIATION_TABS } from '../../../../constants';
import AssociationHeader from '../association-header/AssociationHeader';
import AssociationNavigation from '../association-navigation/AssociationNavigation';
import AssociationServicesWrapper from '../events-association-services/AssociationServicesWrapper';

import AssociationSourcesWrapper from '../events-association-sources/AssociationSourcesWrapper';
import classes from './EventsAssociationsWrapper.module.scss';

const EventsAssociationsWrapper = () => {
  const { t: translate } = useTranslation();
  const { eventName = '', eventVersion = '', associationTab } = useParams();

  return (
    <div className={classes['events-association-wrapper']} id="association-container">
      <BreadcrumbComponent />

      <AssociationHeader header={eventName} subHeader={`${translate('event_associations.header_text_associations')}`} status="active" description={`${translate('event_associations.association_description')}`} version={eventVersion} containerHeaderId="association-header-container" containerId="association-container" />

      <AssociationNavigation />
      {
        associationTab === EVENT_ASSOCIATION_TABS.SERVICES && (
          <AssociationServicesWrapper eventName={eventName} eventVersion={eventVersion} />
        )
      }
      {
        associationTab === EVENT_ASSOCIATION_TABS.SOURCES && (
          <AssociationSourcesWrapper eventName={eventName} eventVersion={eventVersion} />
        )
      }
    </div>
  );
};

export default EventsAssociationsWrapper;
